export const DISCLAIMER_TYPE = 'evp_configurator_disclaimer';
export const MAX_LEGACY_DISCLAIMERS = 50;

export function validateLegacyDisclaimerIds(ids) {
  if (ids === undefined) return [];
  if (!Array.isArray(ids) || ids.length > MAX_LEGACY_DISCLAIMERS ||
      ids.some((id) => typeof id !== 'string' || !/^gid:\/\/shopify\/Metaobject\/\d+$/.test(id)) ||
      new Set(ids).size !== ids.length) return [`Disclaimers must contain up to ${MAX_LEGACY_DISCLAIMERS} unique disclaimer references.`];
  return [];
}

export function plainTextToRichText(text) {
  return {type: 'root', children: text.replace(/\r\n?/g, '\n').split('\n').map((value) => ({
    type: 'paragraph', children: [{type: 'text', value}],
  }))};
}

export function richTextToPlainText(value) {
  const node = typeof value === 'string' ? JSON.parse(value) : value;
  if (!node) return '';
  if (node.type === 'text') return node.value || '';
  return (node.children || []).map(richTextToPlainText).join(['root', 'list'].includes(node.type) ? '\n' : '');
}

export function disclaimerFromMetaobject(object) {
  if (!object || object.type !== DISCLAIMER_TYPE) return null;
  const fields = Object.fromEntries(object.fields.map(({key, value}) => [key, value]));
  return {id: object.id, handle: object.handle, name: fields.name || '', content: fields.content || '',
    text: richTextToPlainText(fields.content), fingerprint: JSON.stringify([object.handle, fields.name, fields.content])};
}
